import React from 'react';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { getLanguage } from '../../../store/storeFunctions';

import esg_schema_cz from '../../../img/esg_schema_cz.svg';
import esg_schema_de from '../../../img/esg_schema_de.svg';
import esg_schema_en from '../../../img/esg_schema_en.svg';
import esg_schema_sk from '../../../img/esg_schema_sk.svg';

class ESGMethodology extends React.Component {

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (
            <>
                <div className="esg-methodology">
                    <div className="esg-m-content">
                        <div className="esg-m-description"><Translate id="Report.ESG.Methodology" /></div>
                        <div className="esg-m-title"><div className="esg-m-title-number"><span>1</span></div><Translate id="Report.ESG.Methodology.InputCharacteristics" /></div>
                        <div className="esg-m-description"><Translate id="Report.ESG.Methodology.InputCharacteristics.Description" /></div>
                        <div className="esg-m-title"><div className="esg-m-title-number"><span>2</span></div><Translate id="Report.ESG.Methodology.Subfactors" /></div>
                        <div className="esg-m-description"><Translate id="Report.ESG.Methodology.Subfactors.Description" /></div>
                        <div className="esg-m-title"><div className="esg-m-title-number"><span>3</span></div><Translate id="Report.ESG.Methodology.Factors" /></div>
                        <div className="esg-m-description"><Translate id="Report.ESG.Methodology.Factors.Description" /></div>
                        <div className="esg-m-title"><div className="esg-m-title-number"><span>4</span></div><Translate id="Report.ESG.Methodology.Score" /></div>
                        <div className="esg-m-description"><Translate id="Report.ESG.Methodology.Score.Description" /></div>
                    </div>
                    <div className="esg-m-image">
                        <img alt="ESG Methology and Scheme Image" src={this.getImage()} style={{ height: '100%', verticalAlign: 'middle', objectFit: 'contain' }} />
                    </div>
                </div>
            </>
        )
    }

    getImage() {
        switch (getLanguage()) {
            case 'cs-CZ':
                return esg_schema_cz;
            case 'sk-SK':
                return esg_schema_sk;
            case 'en-US':
                return esg_schema_en;
            case 'de-DE':
                return esg_schema_de;
            default:
                return "";
        }
    }

}

export default connect(state => state.report)(ESGMethodology);